import { UIHeading1, UIHeading4 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './NewbuildingMortgageSection.css';

export interface INewbuildingMortgageSectionProps {
  header: string;
  showHeader?: boolean;
  redesignPage: boolean;
}

export const NewbuildingMortgageSection: React.FC<INewbuildingMortgageSectionProps> = ({
  children,
  showHeader,
  header,
  redesignPage,
}) => {
  return (
    <div
      className={cn(!redesignPage && styles['container'], redesignPage && styles['container_redesigned'])}
      data-testid="NewbuildingMortgageSection"
      id="servicePlaceUnderMap"
    >
      {showHeader &&
        (redesignPage ? (
          <div className={styles['title']}>
            <UIHeading1 as="h1">{header}</UIHeading1>
          </div>
        ) : (
          <div className={styles['title']}>
            <UIHeading4 as="h3">{header}</UIHeading4>
          </div>
        ))}
      {children}
    </div>
  );
};
